var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"pagination",attrs:{"layout":"total, prev, pager, next","page-size":_vm.pageSize,"current-page":_vm.currPage,"total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }